import { createSlice } from '@reduxjs/toolkit'
import Constants from '../../Constants';

export const FinanceProjectFilterSlice = createSlice({
    name: "finance_project_filters",
    initialState: {
        Account_Name: { label: '', value: '' }
    },
    reducers: {
        updateFinanceFilters: (state, action) => {
            state = action.payload;
            return state;
        },
        setDefaultValueForFinanceFilter: (state, action) => {
            if (action.payload.type === Constants.ACCOUNT_NAME) {
                state.Account_Name = action.payload.payload
            }
            if (action.payload.type === Constants.DATE_RANGE) {
                state.Date_Range = action.payload.payload
            }

            return state;
        }
    },
})
export const { updateFinanceFilters } = FinanceProjectFilterSlice.actions
export const { setDefaultValueForFinanceFilter } = FinanceProjectFilterSlice.actions

export default FinanceProjectFilterSlice.reducer